module.exports = __webpack_public_path__ + "img/WAF.797696d.svg";